<template>
  <ul
    v-if="items.length"
    class="filtersList filtersList--summary"
  >
    <li
      v-for="(item, i) in items"
      :key="i"
    >
      <span v-html="item" />
    </li>
  </ul>
</template>

<script setup>
defineProps({
	items: {
		type: Array,
		required: true
	}
});
</script>
